import { FinnairAirBoundsResponse } from '@fcom/dapi/api/models/finnair-air-bounds-response';
import { FinnairBoundFareFamily } from '@fcom/dapi/api/models/finnair-bound-fare-family';
import { FinnairBoundGroup } from '@fcom/dapi/api/models/finnair-bound-group';
import { FinnairBoundItemWithLocation } from '@fcom/common-booking/interfaces/flight-selection.interface';

export interface FinnairBoundGroupWithLocation extends FinnairBoundGroup {
  details: FinnairBoundItemWithLocation;
  hasSpecialOffers?: boolean;
}

export interface FinnairAirBounds extends FinnairAirBoundsResponse {
  boundGroups: FinnairBoundGroupWithLocation[];
}

export enum SelectionPhase {
  OUTBOUND = 'OUTBOUND',
  INBOUND = 'INBOUND',
  MULTICITY = 'MULTICITY',
}

export interface AirBoundsSelectedFareFamily {
  outbound: {
    fareFamily: FinnairBoundFareFamily | undefined;
  };
  inbound: {
    fareFamily: FinnairBoundFareFamily | undefined;
  };
}
